/*
 * Copyright (c) by INFODATA-GROUP. All rights reserved.
 * No part of this publication may be reproduced, distributed,
 * or transmitted in any form or by any means, including photocopying, recording,
 * or other electronic or mechanical methods, without the prior written permission of the publisher,
 * except in the case of brief quotations embodied in critical
 * reviews and certain other noncommercial uses permitted by copyright law.
 *  author : vhe
 *  date : 02/03/2021 07:39
 */

import { Entity } from './entity/entity';

export class RadioLightItem extends Entity {
  public id: string;
  public label: string;
  public icon: string;
  public color: string;

  constructor(id: string, label: string, icon?: string, color?: string) {
    super();
    this.id = id;
    this.label = label;
    this.icon = icon;
    this.color = color;
  }

  getId(): string {
    return this.id;
  }

  getLabel(): string {
    return this.label;
  }

  serialize(): any {
    return;
  }
}
